import { render, staticRenderFns } from "./iqFieldICOR.vue?vue&type=template&id=3629efd1&scoped=true&"
import script from "./iqFieldICOR.vue?vue&type=script&lang=js&"
export * from "./iqFieldICOR.vue?vue&type=script&lang=js&"
import style0 from "./iqFieldICOR.vue?vue&type=style&index=0&id=3629efd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3629efd1",
  null
  
)

component.options.__file = "iqFieldICOR.vue"
export default component.exports